export class RefundWorklistRequest{
    centerId:string;
    queryParam:string;

    constructor(centerId:string,queryParams:string){
        this.centerId = centerId;
        this.queryParam = queryParams;
    }
}